import { Controller } from "@hotwired/stimulus"

// After each Turbo Frame loads:
//  - hides the skeleton placeholder
//  - shows the frame only if it has results
//  - hides the TOC badge if no results
export default class extends Controller {
  connect() {
    this._onFrameLoad = this._onFrameLoad.bind(this)
    document.addEventListener("turbo:frame-load", this._onFrameLoad)
  }

  disconnect() {
    document.removeEventListener("turbo:frame-load", this._onFrameLoad)
  }

  scrollToSection(event) {
    event.preventDefault()
    const targetId = event.params.target
    const el = document.getElementById(targetId) || document.getElementById(`${targetId}-wrapper`)
    if (el) el.scrollIntoView({ behavior: "smooth", block: "start" })
  }

  _onFrameLoad(event) {
    const frame = event.target
    if (!frame.id?.startsWith("search-group-")) return

    const skeleton = document.getElementById(`${frame.id}-skeleton`)
    const wrapper  = document.getElementById(`${frame.id}-wrapper`)
    const tocLink  = this.element.querySelector(`a[href="#${frame.id}"]`)

    const hasResults = frame.querySelector(".search-group-header") !== null

    // Always hide the skeleton once loaded
    if (skeleton) skeleton.style.display = "none"

    if (hasResults) {
      frame.style.display = ""
    } else {
      // No results — hide wrapper entirely and TOC badge
      if (wrapper) wrapper.style.display = "none"
      if (tocLink) tocLink.style.display = "none"
    }
  }
}
